const actions = {
  itemsApiName: 'ITEMS_API',
  requestItems: 'items/request',
}

export default actions
